function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs32"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 6.8173871,
  y1: 49.935669,
  x2: 6.8173871,
  y2: 59.935669,
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeLinecap: "round",
  id: "line20"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 11.817388,
  y1: 49.935669,
  x2: 11.817388,
  y2: 59.935669,
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeLinecap: "round",
  id: "line22"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 16.817387,
  y1: 49.935669,
  x2: 16.817387,
  y2: 59.935669,
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeLinecap: "round",
  id: "line24"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 21.817387,
  y1: 49.935669,
  x2: 21.817387,
  y2: 59.935669,
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeLinecap: "round",
  id: "line26"
});

var SvgTick = function SvgTick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 65.154121,
    viewBox: "-4.5 0 35 65.154122",
    fill: "#000000",
    preserveAspectRatio: "none",
    id: "svg28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    d: "m 5.4043611,63.93255 c -0.0031,-9.5e-5 -0.010213,-4.68e-4 -0.021068,-0.0012 -0.021724,-0.0017 -0.058399,-0.005 -0.1078468,-0.0128 C 5.1765103,63.90302 5.0267786,63.87101 4.8428425,63.804533 4.4772093,63.672372 3.9681082,63.401622 3.4485259,62.840647 2.4089457,61.718168 1.2756641,59.374155 1.2752847,54.49339 c -3.636e-4,-4.880762 1.1325361,-7.220237 2.1719416,-8.338448 0.5194971,-0.55889 1.0285547,-0.827644 1.3941683,-0.958254 0.1839244,-0.06571 0.3336499,-0.09716 0.4325901,-0.112197 0.049444,-0.0075 0.08611,-0.0109 0.1078423,-0.01243 0.010854,-7.6e-4 0.017967,-0.0011 0.021068,-0.0012 l 5.676e-4,-8e-6 19.2437064,0.03882 -19.7542355,-0.0435 c 0,0 -4.07676747,-0.453743 -4.07599737,9.426187 7.656e-4,9.879918 4.58435237,9.889177 4.58435237,9.889177 m 0.00309,-0.44908 -0.0013,-5e-6 H 5.402246 m 0.0022,6e-6 h 2.8e-5 l 0.0015,4e-6 1.828e-4,10e-7 -0.0012,-3e-6 m -5.686e-4,-10e-7 5.686e-4,10e-7 m -0.0028,-8e-6 0.0028,8e-6 m -0.0028,-8e-6 c -4.587e-4,-10e-7 -9.074e-4,-2e-6 -9.512e-4,0.449087 m 9.512e-4,-0.449087 -9.074e-4,-2e-6 -0.5966501,0.343845 m 0.6002329,-0.343799 19.2437178,0.03888 m 0,0 -9.41e-4,-10e-7 0.0015,4e-6 v 0 m -5.48e-4,-10e-7 0.0029,8e-6 m -0.0029,-8e-6 5.48e-4,10e-7 m 0,0 0.0013,1e-6 8.22e-4,3e-6 m -0.0023,-7e-6 c 0.0014,-8.6e-5 0.0039,-1.71e-4 0.0072,-3.45e-4 0.0035,-1.74e-4 0.0083,-4.33e-4 0.01384,-6.63e-4 0.02174,-0.0016 0.05837,-0.005 0.107803,-0.01246 0.09901,-0.01506 -0.709009,0.556781 -0.525122,0.491021 0.36567,-0.130662 0.534533,0.245277 2.104278,-1.637482 1.039371,-1.118313 2.065141,-3.365892 2.064761,-8.246657 -2.88e-4,-4.880773 -0.778839,-7.240677 -1.818486,-8.363088 -0.519556,-0.560989 -1.028626,-0.831801 -1.394315,-0.963888 -0.183902,-0.06645 -0.333601,-0.09851 -0.43261,-0.113945 -0.04943,-0.0077 -0.08609,-0.01125 -0.107804,-0.01286 -0.01089,-8.02e-4 -0.01797,-0.0011 -0.02109,-0.0012 l -0.364559,19.498338 m 0.368259,-0.636754 c 4.58e-4,3e-6 0.512357,-1.281215 0.512406,-0.832125 m -0.512406,0.832125 h 8.82e-4 l 0.971117,-1.027599 M 24.385371,63.9766 5.3711428,64.378125",
    fill: "#101010",
    stroke: "#101010",
    id: "path18",
    style: {
      strokeWidth: 0.907399
    }
  }), _ref3, _ref4, _ref5, _ref6, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      fillOpacity: 1,
      strokeWidth: 0.0258824
    },
    d: "M 3.7543207,65.097067 C 3.1958842,64.951576 2.584639,64.52694 2.1062809,63.952163 1.019263,62.646044 0.34060907,60.518231 0.09430247,57.643919 c -0.126466,-1.475813 -0.1256629,-3.484539 0.00199,-4.982353 0.271551,-3.186192 1.10421873,-5.507179 2.40786873,-6.71172 0.3750356,-0.346524 0.8596631,-0.625782 1.2643153,-0.728539 0.2033809,-0.05165 0.2726385,-0.05198 10.4500095,-0.05016 l 10.245271,0.0018 -0.0018,9.990588 -0.0018,9.990588 -10.255882,-0.0032 C 4.1173928,65.147623 3.9452295,65.146823 3.7543187,65.097043 Z m 3.5575601,-3.982946 c 0.2985014,-0.10264 0.5520501,-0.36659 0.638729,-0.664933 0.054356,-0.187092 0.056177,-10.390035 0.00189,-10.577146 -0.086671,-0.298714 -0.3384986,-0.560817 -0.64091,-0.667062 -0.2266062,-0.07961 -0.5343346,-0.06115 -0.7595922,0.04558 -0.312011,0.147831 -0.5181734,0.429479 -0.5684134,0.776538 -0.034837,0.240657 -0.036583,10.025664 -0.00183,10.266333 0.05805,0.402023 0.3217636,0.7119 0.7109265,0.835376 0.1607612,0.05101 0.4479669,0.0442 0.6192047,-0.01468 z m 5.0910722,-0.03415 c 0.225398,-0.108061 0.369938,-0.251239 0.481592,-0.477054 l 0.09767,-0.197538 9.36e-4,-5.243865 9.36e-4,-5.243862 -0.0976,-0.197572 c -0.111063,-0.224821 -0.254248,-0.367263 -0.481421,-0.478921 -0.130952,-0.06436 -0.17286,-0.07154 -0.417859,-0.07159 -0.254765,-4.6e-5 -0.283288,0.0053 -0.442733,0.08381 -0.205247,0.100997 -0.387032,0.286088 -0.48393,0.49273 l -0.0694,0.147985 -9.4e-4,5.267059 -9.4e-4,5.267058 0.06883,0.146899 c 0.121452,0.259198 0.355401,0.467087 0.62433,0.55478 0.06931,0.0226 0.193967,0.0327 0.342003,0.02771 0.189269,-0.0064 0.260236,-0.02093 0.378517,-0.07764 z m 4.99519,0.0047 c 0.265314,-0.122102 0.468654,-0.358373 0.551194,-0.640459 0.03697,-0.126341 0.04123,-0.661107 0.04205,-5.281766 8.25e-4,-4.620659 -0.0033,-5.155428 -0.04017,-5.281781 -0.08222,-0.281367 -0.284297,-0.51679 -0.550965,-0.641886 -0.128203,-0.06014 -0.177666,-0.06824 -0.417212,-0.06828 -0.240681,-4.3e-5 -0.288692,0.0079 -0.419773,0.06929 -0.207372,0.09715 -0.392799,0.279333 -0.493344,0.48471 l -0.08348,0.170527 -9.4e-4,5.26703 -9.4e-4,5.267059 0.0689,0.146977 c 0.121553,0.259283 0.355324,0.467008 0.624257,0.554702 0.179205,0.05844 0.543926,0.03507 0.720416,-0.04615 z m 5.023425,-0.01459 c 0.203068,-0.09992 0.385358,-0.285946 0.48184,-0.491702 l 0.0694,-0.147985 9.4e-4,-5.267085 9.4e-4,-5.267059 -0.06934,-0.14801 c -0.09683,-0.20669 -0.27855,-0.391845 -0.483761,-0.492916 -0.159417,-0.07852 -0.187938,-0.08393 -0.442703,-0.08397 -0.244999,-4.4e-5 -0.286909,0.0071 -0.417884,0.07144 -0.227213,0.111577 -0.370449,0.253968 -0.481592,0.478749 l -0.09767,0.197538 -9.36e-4,5.242519 -9.35e-4,5.242518 0.07996,0.168251 c 0.09608,0.202186 0.184781,0.311432 0.339078,0.417631 0.200263,0.137838 0.352658,0.179925 0.618758,0.170883 0.203385,-0.0069 0.25858,-0.01932 0.403912,-0.09084 z",
    id: "path884"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      fillOpacity: 1,
      strokeWidth: 0.0258824
    },
    d: "m 24.310147,51.661549 c -9e-6,-0.469764 0.0035,-0.665592 0.0078,-0.435173 0.0043,0.23042 0.0043,0.614773 1.8e-5,0.854118 -0.0043,0.239345 -0.0078,0.05082 -0.0078,-0.418945 z",
    id: "path1957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.1337636,15.048124 c 0,-0.525842 0.4981952,-0.95213 1.112738,-0.95213 H 19.261148 c 0.614566,0 1.11274,0.426288 1.11274,0.95213 V 43.611941 H 8.1337636 Z",
    stroke: "#101010",
    strokeWidth: 2.05861,
    id: "path810",
    style: {
      display: "inline",
      fill: "none"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick.1a2599fd.svg";
export { ForwardRef as ReactComponent };